import { styled } from '@mui/material/styles';
import { UpgradeIcon } from 'assets/images/icons';

const Wrapper = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    '& svg path': {
        fill: 'var(--primary-main)',
        fillOpacity: 1,
    },
});

export const GatedLabel = ({ children }) => (
    <Wrapper>
        {children}
        <UpgradeIcon />
    </Wrapper>
);

export default GatedLabel;
